export const STUDIO_ROUTE_NAMES = {
  STUDIOPROFILELIST: '',
  STUDIOPROFILEMANAGE: ':id',
  STUDIOLOCATIONLIST: 'locations',
  STUDIOLOCATIONMANAGE: 'location/:id',
  STUDIOPROFILEVIEW: 'studio-profile-view',
  STUDIOROOMLIST : '',
/*ROUTE_NAME*/
};
